import { useEffect, useState } from "react";
import { api, fmtDateTime } from "@/lib/api";
import { Badge } from "@/components/ui/badge";
import { Loader2 } from "lucide-react";

// Kundenakte → „Sendungen“: manuelle Sendungen (ohne Auftrag) an diesen Kunden
export function KundeSendungenTab({ kundeId }) {
  const [list, setList] = useState(null);
  useEffect(() => {
    let alive = true;
    api.get("/versand", { params: { kunde_id: kundeId } }).then((r) => alive && setList(r.data)).catch(() => alive && setList([]));
    return () => { alive = false; };
  }, [kundeId]);
  if (!list) return <div className="py-6 flex justify-center"><Loader2 className="w-5 h-5 animate-spin text-slate-400" /></div>;
  if (!list.length) return <p className="text-sm text-slate-500 py-3" data-testid="kunde-sendungen-leer">Keine manuellen Sendungen an diesen Kunden. Sendungen zu Aufträgen stehen am jeweiligen Auftrag.</p>;
  return (
    <ul className="divide-y divide-slate-100 text-sm" data-testid="kunde-sendungen">
      {list.map((s) => (
        <li key={s.id} className="py-2 flex items-center gap-3" data-testid={`kunde-sendung-${s.id}`}>
          <span className="font-mono text-xs text-slate-700 w-40 truncate">{s.tracking_number || "—"}</span>
          <Badge variant={s.status === "fehler" ? "destructive" : "outline"}>{s.status}</Badge>
          <span className="text-slate-600">{s.versandart === "kleinpaket" ? "Kleinpaket" : "DHL Paket"} · {String(s.gewicht_kg).replace(".", ",")} kg</span>
          <span className="ml-auto text-xs text-slate-500">{fmtDateTime(s.created_at)}</span>
        </li>
      ))}
    </ul>
  );
}
